import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { FavoriteDetailDto, FavoriteDto } from '@/modules/favorite/dto/favorite.dto.ts';
import type { FavoriteShort, Favorite } from '@/modules/favorite/types/favorite.type.ts';
import { FOLDER_TABLE_ID } from '@/modules/favorite/consts/favorite.consts.ts';

export class FavoriteAdapter {
  private static mapShort(response: FavoriteDto): FavoriteShort {
    return {
      id: response.FAV_ID,
      name: response.Название,
      parents: response.PARENTS,
      parentId: response.PARENT_ID,
      tableId: response.PARENT_TABLE_ID,
      isFolder: response.PARENT_TABLE_ID === FOLDER_TABLE_ID,
    };
  }

  static mapShortList(response: ItemsDto<FavoriteDto>) {
    return response.items.map(FavoriteAdapter.mapShort);
  }

  private static map(response: FavoriteDetailDto): Favorite {
    return {
      parentTableId: response.PARENT_TABLE_ID,
      parentId: response.PARENT_ID,
      gparentTableId: response.GPARENT_TABLE_ID,
      gparentId: response.GPARENT_ID,
    };
  }

  static mapList(response: ItemsDto<FavoriteDetailDto>) {
    return response.items.map(FavoriteAdapter.map);
  }
}
